module.exports = __webpack_public_path__ + "img/placeOrder.8277cc2f.jpg";